import React, { useState } from 'react';
import Calendar from 'react-calendar';
import { useSubBuilder } from '../../../../context/subBuilder/useSubBuilder';

import { getXDaysInFuture, getXWorkingDaysInFuture, isExcludedDate } from '../../../../context/subBuilder/utils';

import SubBuilderStep from '../components/SubBuilderStep';
import BackgroundBlackOutlineLarge from '../svgs/BlackOutlineLarge';


const DateStep: React.FunctionComponent = () => {

 
  const {state, settings, actions} = useSubBuilder()

  const excludedDates = settings.steps.date.excludedDates

  const [minDate] = useState(getXWorkingDaysInFuture(settings.steps.date.settings.deliveryTime, excludedDates)) 
  
  const [maxDate] = useState(getXDaysInFuture(settings.steps.date.settings.deliveryMax)) 


  return (
    <SubBuilderStep className="sub-builder-date" index={6} stepConfig={settings.steps.date}>
      <div className="sub-builder-container-sm relative react-calendar-wrap">
        <BackgroundBlackOutlineLarge />
        <Calendar
          onChange={(date: Date) => {
            actions.setDeliveryDate(date)
            actions.moveStep(+1)
          }}
          maxDate={maxDate}
          minDate={minDate}
          value={state.deliveryDate}
          minDetail={'month'}
          tileDisabled={({ date }) => (date.getDay() === 0 || isExcludedDate(date, excludedDates))}
        />
      </div>
    </SubBuilderStep>
  )
}

export default DateStep